import React from 'react'

import TeamSquadListTemplate from './TeamSquadListTemplate';

function TeamSquadList({keepers, defenders, midfielders, attackers}) {

    return (
        <div className="my-3">
            {keepers?.map((player, index) => {
                return <TeamSquadListTemplate key={index} player={player} />
            })}
            <br />
            {defenders?.map((player, index) => {
                return <TeamSquadListTemplate key={index} player={player} />
            })}
            <br />
            {midfielders?.map((player, index) => {
               return <TeamSquadListTemplate key={index} player={player} />
            })}
            <br />
            {attackers?.map((player, index) => {
                return <TeamSquadListTemplate key={index} player={player} />
            })}
            <br />
            <br/>
        </div>
    )
}
export default TeamSquadList